import { useEffect, useState } from "react";
import HeaderButton from "./headerButton";
import { RiMenuLine } from "@remixicon/react";
import Flex from "../../atom/flex";

const HeaderDropdownMenu = props => {
    const { 
        onHover = () => {}, 
        data, 
        mobile, 
        secondary, 
        visible, 
        dropdownKey, 
        activeKey 
    } = props;
    const { options, label } = data;

    const [dropdownActive, setDropdownActive] = useState(false);
    
    useEffect(() => {
        if(!mobile || (mobile && secondary)) {
            if(activeKey !== dropdownKey) {
                setDropdownActive(false);
            } else {
                setDropdownActive(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeKey]);

    useEffect(() => {
        if(!visible) {
            setDropdownActive(false);
        }
    }, [visible]);

    return (<>
        {mobile 
            ? secondary 
                ? <label 
                    onClick={() => onHover(!dropdownActive, dropdownKey)}
                >
                        {label}
                    </label> 
                : <RiMenuLine 
                    className="kt-header-button" 
                    onClick={() => {
                        onHover(!dropdownActive);
                        setDropdownActive(actual => !actual);
                    }}
                /> 
            : <HeaderButton
                href={data.path}
                className={dropdownActive ? "kt-header-button-active" : ""}
                onMouseEnter={() => onHover(true, dropdownKey)}
                onMouseLeave={() => onHover(false, dropdownKey)}
            >
                {label}
            </HeaderButton>
        }
        {(mobile && !secondary)
            ? <Flex
                vertical
                align="end"
                className={`kt-header-dropdown-menu ${dropdownActive ? "kt-header-dropdown-menu-active" : ""}`}
            >
                {options.map((row, index) => row.options 
                    ? <HeaderDropdownMenu 
                        mobile 
                        secondary 
                        key={index} 
                        data={row} 
                        visible={dropdownActive} 
                        onHover={onHover}
                        activeKey={activeKey}
                        dropdownKey={index}
                    /> 
                    : <a key={index} href={row.path}>{row.label}</a>
                )}
            </Flex>
            : <Flex
                vertical
                align="start"
                className={`kt-header-dropdown-menu ${dropdownActive ? "kt-header-dropdown-menu-active" : ""} ${secondary ? "kt-header-dropdown-menu-secondary" : ""}`}
                onMouseEnter={() => onHover(true, dropdownKey)} 
                onMouseLeave={() => onHover(false, dropdownKey)}
            >
                <h1>{label}</h1>
                {options.map((row, index) => <a key={index} href={row.path}>{row.label}</a>)}
            </Flex>
        }
    </>);
}

export default HeaderDropdownMenu;